import { render, staticRenderFns } from "./detail.vue?vue&type=template&id=f59a0210&scoped=true&"
import script from "./detail.js?vue&type=script&lang=js&"
export * from "./detail.js?vue&type=script&lang=js&"
import style0 from "./detail.vue?vue&type=style&index=0&id=f59a0210&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f59a0210",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data2/workspace/sc-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f59a0210')) {
      api.createRecord('f59a0210', component.options)
    } else {
      api.reload('f59a0210', component.options)
    }
    module.hot.accept("./detail.vue?vue&type=template&id=f59a0210&scoped=true&", function () {
      api.rerender('f59a0210', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/seller/components/goodsDy/detail.vue"
export default component.exports